<template>
	<div class="common_wrapper">
		<!--    头部开始home-->
		<header class="common_headers">
			<div class="common_container" style="display: flex;justify-content: center">
				<div class="icon">
					<img src="/static/image/logo.png" alt />
				</div>
				<el-menu :default-active="activeIndex2+''" class="el-menu-demo" mode="horizontal" @select="handleSelect"
					background-color="#fff" text-color="#000000" active-text-color="#4278F9">
					<el-menu-item index="1" class="padd font1">首页</el-menu-item>
					<el-submenu index="2">
						<template slot="title" class="font1">公司产品</template>
						<el-menu-item index="2-1">硬件产品</el-menu-item>
						<el-menu-item index="2-2">对接软件查询（PDA使用）</el-menu-item>
						<!--            <el-menu-item index="2-3">软件产品</el-menu-item>-->
						<el-menu-item index="2-4">收单易（可以手机端使用）</el-menu-item>
						<el-menu-item index="2-5">供应链数据共享系统</el-menu-item>
						<el-menu-item index="2-6">拣货系统</el-menu-item>
						<el-menu-item index="2-7">注册-授权查询管理</el-menu-item>
						<el-menu-item index="2-8">定制项目涉及范围</el-menu-item>
            <el-menu-item index="2-9">手机App下载工具</el-menu-item>
					</el-submenu>
					<el-submenu index="3">
						<template slot="title" class="font1">重点方案</template>
						<!--            <el-menu-item index="3-1">飞鱼介绍</el-menu-item>-->
						<!-- <el-menu-item index="3-18">新速云功能架构测试内容</el-menu-item> -->
						<el-menu-item index="3-17">新速云功能架构</el-menu-item>
						<el-menu-item index="3-2">新速云介绍</el-menu-item>
						<el-menu-item index="3-9">APP新版UI界面</el-menu-item>
						<el-menu-item index="3-3">软件之间数据互传工具介绍</el-menu-item>
						<!-- <el-menu-item index="3-4">讯华小商城介绍</el-menu-item> -->
						<el-menu-item index="3-7">讯华收单易介绍</el-menu-item>
						<el-menu-item index="3-5">酒水行业线上下单及收款应用</el-menu-item>
						<el-menu-item index="3-6">供应链数据共享系统</el-menu-item>
						<el-menu-item index="3-8">PDA扫码支付演示视频</el-menu-item>
						<el-menu-item index="3-10">PDA新增电子传秤功能</el-menu-item>
						<el-menu-item index="3-11">PDA新增拣货功能</el-menu-item>
						<el-menu-item index="3-12">PDA快速盘点功能调查问卷</el-menu-item>
						<el-menu-item index="3-13">新速云简账系统介绍</el-menu-item>
						<el-menu-item index="3-15">新速云简帐固定资产介绍</el-menu-item>
						<el-menu-item index="3-14">PDA新增分拣出库功能（包含装箱）</el-menu-item>
						<el-menu-item index="3-16">讯联VPN连接方法</el-menu-item>
            <el-menu-item index="3-19">T+企业授权绑定</el-menu-item>
						<!--            <el-menu-item index="2-3">软件产品</el-menu-item>-->
					</el-submenu>
					<!--          <el-menu-item index="3" class="font1">重点方案</el-menu-item>-->
					<el-menu-item index="8" class="font1">新速云下载</el-menu-item>
					<!-- <el-submenu index="8">
					  <template slot="title" class="font1">新速云下载</template>
					  <el-menu-item index="8-1">新速云批发版手机端</el-menu-item>
					  <el-menu-item index="8-2">新速云收单易</el-menu-item>
					  <el-menu-item index="8-3">讯联VPN</el-menu-item>
					</el-submenu> -->
					<!-- <el-menu-item index="8" class="font1">新速云APP下载</el-menu-item> -->
					<el-menu-item index="4" class="font1">资料下载</el-menu-item>
					<el-menu-item index="5" class="font1">伙伴专区</el-menu-item>
					<el-menu-item index="6" class="font1">荣誉资质</el-menu-item>
					<!-- <el-menu-item index="7" class="font1">疑难解答</el-menu-item> -->
					<el-submenu index="7">
						<template slot="title" class="font1">疑难解答</template>
						<el-menu-item index="7-1">关于WIFI网络一些问题的解决方案</el-menu-item>
						<el-menu-item index="7-2">应该如何选择合适好用的无线路由器</el-menu-item>
						<el-menu-item index="7-3">二级路由器桥接的正确方式</el-menu-item>
						<el-menu-item index="7-4">PDA的WIFI如何开启无缝漫游功能</el-menu-item>
						<el-menu-item index="7-5">验证服务器连接信息工具操作说明</el-menu-item>
						<el-menu-item index="7-6">APP使用说明</el-menu-item>
						<el-menu-item index="7-7">APP使用技巧</el-menu-item>
					</el-submenu>
				</el-menu>
			</div>
		</header>
		<div class="common_session">
			<!--    头部结束end-->
			<div class="common_wrap_container">
				<div class="common_banner">
					<!-- 全屏插槽 -->
					<slot name="banner"></slot>
				</div>
				<div class="common_wrap_container_wrap">
					<!-- 中部区域插槽 -->
					<slot name="subject"></slot>
				</div>
			</div>
			<div class="common_footer-wrap">
				<!--        底部简单提示-->
				<div class="common_footer-other">
					<slot name="other-tips"></slot>
				</div>
				<div class="common_footer">
					<div class="nav">
						<ul class="nav_ul">
							<li>
								<router-link to="/">首页</router-link>
							</li>
							<li>
								<router-link to="/companyProducts">公司产品</router-link>
							</li>
							<li>
								<router-link to="/MajorProject">重点方案</router-link>
							</li>
							<li>
								<router-link to="/Download">资料下载</router-link>
							</li>
							<li>
								<router-link to="/tempPartner">伙伴专区</router-link>
							</li>
							<li>
								<router-link to="/QualificationHonor">资质荣誉</router-link>
							</li>
							<li>
								<router-link to="/Troubleshooting">疑难解答</router-link>
							</li>
						</ul>
					</div>
					<div class="common_comInfo">电话：0760-89982939 传真：0760-88860778 地址：广东省中山市港口镇港口大道11号办公楼三楼</div>
					<div class="common_comInfo"><a href="https://beian.miit.gov.cn">粤ICP备14095454号-1</a></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Axios from "@/request/axiosReq"
	export default {
		name: "common",
		props: ["activeIndex2"],
		methods: {
			toLogin() {
				console.log("111");
				var _this = this;
				this.$confirm('是否登陆', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					_this.$router.push('/login')
				}).catch(() => {

				});
			},
      //下载
      getAppUpdate(){
        var url = 'http://www.symhua.net:999/Android_PhoneAPP_Market/Android_Application_6_5/phoneappupdate2022.ZIP';
        console.log(url)
        window.open(url, '_blank');
      },
			handleSelect(e) {
				switch (e) {
					case "1":
						this.$router.push({
							path: "/"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "2-1":
						this.$router
							.push({
								path: "/companyProducts",
								query: {
									type: 1
								}
							})
							.catch(e => {
								this.$router.go(0);
							});
						break;
					case "2-2":
						this.$router
							.push({
								path: "/AndroidList",
							})
							.catch(e => {
								this.$router.go(0);
							});
						// console.log(e);
						break;
					case "2-3":
						this.$router
							.push({
								path: "/companyProducts",
								query: {
									type: 3
								}
							})
							.catch(e => {
								this.$router.go(0);
							});
						// console.log(e);
						break;
						// case "3":
						//   console.log(e);
						//   this.$router.push({ path: "/MajorProject" }).catch(e => {
						//     this.$router.go(0);
						//   });
						//   break;
					case "2-4":
						console.log(e);
						this.$router.push({
							path: "/mallQuery"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "2-5":
						console.log(e);
						this.$router.push({
							path: "/SupplyDataSystemDown"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "2-6":
						console.log(e);
						this.$router.push({
							path: "/PickingSystem"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "2-7":
						console.log(e);
						this.$router.push({
							path: "/tempZC"
						}).catch(e => {
							// this.$router.go(0);
						});
						break;

					case "2-8":
						this.$router.push({
							path: "/CustomScope"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
          case "2-9":
          	this.$router.push({
          		path: "/AppPhone"
          	}).catch(e => {
          		this.$router.go(0);
          	});
          	break;
					case "3-1":
						console.log(e);
						this.$router.push({
							path: "/FlyingInfo"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
          case "3-17":
          	console.log(e);
          	this.$router.push({
          		path: "/newProject"
          	}).catch(e => {
          		this.$router.go(0);
          	});
          	break;
					case "3-2":
						console.log(e);
						this.$router.push({
							path: "/MajorProject"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "3-3":
						console.log(e);
						this.$router.push({
							path: "/dataMangerSearch"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "3-4":
						console.log(e);
						this.$router.push({
							path: "/SySmartShopMall"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "3-5":
						console.log(e);
						this.$router.push({
							path: "/ClassIc"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "3-6":
						console.log(e);
						this.$router.push({
							path: "/SupplyDataSystem"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "3-7":
						console.log(e);
						this.$router.push({
							path: "/SmAllOrderInfo"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "3-8":
						this.$router.push({
							path: "/PDAVideoPlayback"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "3-9":
						this.$router.push({
							path: "/AppNewUi"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "3-10":
						this.$router.push({
							path: "/PDACall"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "3-11":
						this.$router.push({
							path: "/PDAPicking"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "3-12":
						this.$router.push({
							path: "/PDAInventory"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "3-13":
						this.$router.push({
							path: "/FinancialSystem"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "3-14":
						this.$router.push({
							path: "/PDASortingWarehousing"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "3-15":
						this.$router.push({
							path: "/FixedAssets"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "3-16":
						this.$router.push({
							path: "/xunlian"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
            case "3-19":
            	this.$router.push({
            		path: "/Tbind"
            	}).catch(e => {
            		this.$router.go(0);
            	});
            	break;
					case "4":
						console.log(e);
						this.$router.push({
							path: "/Download"
						}).catch(e => {
							this.$router.go(0);
						});
						break;

						// case "5":
						//   this.$router.push({ path: "/Partner" }).catch(e => {
						//     this.$router.go(0);
						//   });
						//   break;
					case "5":
						this.$router.push({
							path: "/tempPartner"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "6":
						this.$router.push({
							path: "/QualificationHonor"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "7-1":
						this.$router.push({
							path: "/Troubleshooting"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "7-2":
						this.$router.push({
							path: "/selWIFI"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "7-3":
						this.$router.push({
							path: "/routeConnect"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "7-4":
						this.$router.push({
							path: "/PDAWIFI"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
						break;
					case "7-5":
						this.$router.push({
							path: "/verifyServerConnection"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "7-6":
						this.$router.push({
							path: "/AppInstructions"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "7-7":
						this.$router.push({
							path: "/AppSkills"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "8":
						this.$router.push({
							path: "/AppModile"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "8-2":
						this.$router.push({
							path: "/AppDownload"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
					case "8-3":
						this.$router.push({
							path: "/AppVpn"
						}).catch(e => {
							this.$router.go(0);
						});
						break;
				}
			}
		}
	};
</script>
<style scoped>
	* {
		margin: 0;
		padding: 0;
	}

	ul {
		list-style: none;
	}

	.common_wrapper {
		width: 100%;
		height: 100%;
		margin: auto;
		-webkit-overflow-scrolling: touch;
		/*display: flex;*/
		/*flex-direction: column;*/
	}

	/*头部*/
	.common_headers {
		height: 75px;
		width: 100%;
		/*min-width: 1220px;*/
		background-color: #fff !important;
		color: #2d3237 !important;
		box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);
		font-size: 11px;
		box-sizing: border-box;
		padding-top: 10px;
		position: relative;
		z-index: 999;
	}

	.common_container {
		width: 1200px;
		height: 60px;
		margin: auto;
		display: flex;
		/* margin-top: 3px; */
	}

	.common_container .loginSty {
		/* flex: 1; */
		height: 60px;
		line-height: 60px;
		font-size: 16px;
		padding-left: 15px;
		/* padding-right: 15px; */
		font-weight: 400;
		max-width: 150px;
		position: relative;
	}

	.common_container .loginSty .loginStyItem {
		display: block;
		overflow-x: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.common_container .loginSty .loginStyItem .row {
		transform: rotate(90deg);
		position: absolute;
		right: -10px;
		color: #999;
	}

	.common_container .loginSty .loginStyItem ul {
		list-style: none;
		position: absolute;
		top: 60px;
		right: -5px;
		z-index: 9999;
		padding-top: 3px;
	}

	.common_container .loginSty .loginStyItem ul li {
		list-style: none;
		width: 150px;
		height: 30px;
		line-height: 30px;
		color: #666 !important;
		background: #FFF;
		overflow: hidden;
	}

	.common_container .loginSty .loginStyItem ul li:hover {
		background: #ebebeb;
		cursor: pointer;
	}

	.common_container .loginSty:hover {
		color: rgb(66, 120, 249);
		cursor: pointer;
	}

	.common_container .loginSty .loginStyItem:hover li {
		animation: pullAni 0.2s;
		animation-fill-mode: forwards;
	}

	.common_container .loginSty .loginStyItem:hover .row {
		/* animation: rotateAni 0.3s ease-in; */
		/* animation-fill-mode:forwards; */
		transform: rotate(270deg);
	}

	.common_banner {
		width: 100%;
	}

	@keyframes pullAni {
		from {
			height: 0px;
		}

		to {
			height: 40px;
		}
	}

	.common_container img {
		/*height: 55px;*/
		width: 150px;
	}

	.common_container .icon {
		flex: 1;
		text-align: left;
		display: flex;
		align-items: center;
	}

	.common_container .el-menu-item {
		height: 60px;
		line-height: 60px;
		background: #fff !important;
		/* color:#2d3237 !important; */
		font-size: 18px !important;
	}

	.common_container .el-menu-item:hover {
		/* /* background: #FFF !important; */
		border-bottom-color: rgb(66, 120, 249) !important;
		color: rgb(66, 120, 249) !important;
	}

	.is-active {
		border-bottom-color: rgb(66, 120, 249) !important;
		color: rgb(66, 120, 249) !important;
	}

	.el-submenu {
		height: 60px;
		line-height: 60px;
		background: rgb(66, 120, 249) !important;
	}

	.padd {
		padding-left: 30px;
		padding-right: 30px;
	}

	.font1 {
		font-size: 16px;
		padding: 0 22px;
		height: 60px;
		line-height: 60px;
	}

	.common_session {
		height: calc(100% - 70px);
		overflow: auto;
	}

	.common_wrap_container {
		min-height: 100%;
		padding-top: 1px;
	}

	.common_wrap_container_wrap {
		width: 1200px;
		padding-bottom: 170px;
		margin: auto;
	}

	/*底部*/
	.common_footer-wrap {
		width: 100%;
		/*min-width: 1200px;*/
		height: 160px;
		margin-top: -160px;
	}

	.common_footer-wrap .common_footer-other {
		width: 1200px;
		/*height: 60px;*/
		height: 90px;
		line-height: 30px;
		font-size: 20px;
		color: red;
		margin: auto;
		font-weight: bold;
		text-align: left;
	}

	/* .el-submenu__title */
	.common_footer {
		width: 100%;
		/*min-width: 1200px;*/
		height: 100px;
		line-height: 100px;
		background: #2d3237;
		color: #fff;
		text-align: center;
		font-size: 12px;

	}

	.common_footer .nav {
		margin: auto;
		display: inherit;
		padding-top: 20px;
	}

	.common_footer .nav .nav_ul {
		display: flex;
		list-style: none;
		justify-content: center;
	}

	.common_footer .nav .nav_ul li {
		width: 100px;
		text-align: center;
		border-right: 1px solid #fff;
		height: 20px;
		line-height: 20px;
		cursor: pointer;
	}

	.nav_ul li a {
		color: #fff;
		text-decoration: none;
	}

	.common_footer .nav .nav_ul li:last-child {
		border-right: none;
	}

	.common_footer .common_comInfo {
		width: 100%;
		text-align: center;
		height: 20px;
		line-height: 20px;
	}

	.common_footer .common_comInfo a {
		color: #FFF;
		text-decoration: none;
	}

	@media screen and (min-width: 980px) and (max-width: 1200px) {
		.common_headers {
			width: 100%;
		}

		.common_container {
			width: 100%;
		}

		.common_wrap_container_wrap {
			width: 100%;
		}

		.common_container {
			width: 100%;
		}

		.common_footer {
			width: 100%;
		}

		.common_session {
			width: 100%;
			/*min-width:980px;*/
		}

		.common_footer-other {
			width: 100%;
		}
	}

	@media screen and (max-width: 979px) {
		.common_headers {
			width: 980px;
			min-width: 980px;
		}

		.common_session {
			width: 980px;
			min-width: 980px;
		}

		.common_wrap_container_wrap {
			width: 980px;
		}

		.common_container {
			width: 980px;
		}

		.common_container {
			width: 980px;
		}

		.common_footer {
			width: 980px;
		}

		.common_footer-other {
			width: 980px !important;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/common/common.vue